/* eslint-disable react/no-unknown-property */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import CircularProgress from '@mui/material/CircularProgress';
import { XWhite as X } from "../../Constants/assets";

/*
This Modal appears when a milestone is reached. Have a different design when the Mileston is the
first one. The handleMilestoneStatus function return the stage of the milestone.
There is 5 different milestone stages
*/
const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.99);
  text-align: center;
  position: fixed;
  font-family: "Roboto", sans-serif;
  z-index: 120;
  animation: zoomIn 0.2s ease-in-out;
  left:0;
  top:0;
  overflow: hidden;
  display:flex;
  justify-content:center;
  align-content:center;
  align-items:center;
`;
const TextContainer = styled.div`
  z-index: 120;
  height:100%;
  display:flex;
  justify-content:center;
  align-content:center;
  align-items:center;
`;
const Br = styled.div`
  height: 10%;
`;

const ButtonContainerLine = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
`;

const VideoModal = ({
  videoLink,
  show,
  setShow
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const divRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        // The click is outside the div, change the state here
        setShow(false);
        setIsLoading(true)
      }
    }

    // Add the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Return a cleanup function to remove the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [divRef, setShow]); // Empty dependency array means this effect runs once on mount and cleanup on unmount



  if (show == false) return null;
  return (
    <InnerContainer>
      <Br />
      {/* {isLoading && 
        <div style={{position:'relative'}}>
          <CircularProgress style={{position:'absolute', top:'100px', right:'280px'}}/> 
        </div>
      } */}
      <div>
        <X    
          onClick={() => {
            setShow(false);
            setIsLoading(false)
          }}
          style={{ cursor: "pointer", fill:"white", right: '20px', top: '20px', position: 'absolute' }}
        />
      </div>
      <TextContainer >
        <iframe  
            title="Tutorial" 
            ref={divRef}
            src={videoLink}
            style={{position:'absolute', left:'0',width:'100%',height:'90%'}} 
            frameBorder="0" 
            allow="autoplay; fullscreen; picture-in-picture" 
            allowfullscreen 
        />
        <script src="https://player.vimeo.com/api/player.js" />
      </TextContainer>
    </InnerContainer>
  );
};

export default React.memo(VideoModal);
